var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['svg-icon', `svg-icon-${_vm.name}`],style:(_vm.svgStyle)},[_c('svg',{attrs:{"fill":"currentColor","aria-hidden":"true","width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }